import { render, staticRenderFns } from "./github.vue?vue&type=template&id=5efa56be&scoped=true&"
import script from "./github.vue?vue&type=script&lang=js&"
export * from "./github.vue?vue&type=script&lang=js&"
import style0 from "./github.vue?vue&type=style&index=0&id=5efa56be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa56be",
  null
  
)

export default component.exports